module.exports = __webpack_public_path__ + "img/star-check-mark.fc6fbe9a.svg";